import { createTheme } from "@material-ui/core";

export const baseTheme = createTheme({
  typography: {
    body1: {
      fontSize: 18,
    },
  },
});
